import Vue from "vue";
export default Vue.extend({
    props: {
        items: [],
    },
    data() {
        return {
            salaryHeaders: [
                { text: "Name", value: "name" },
                { text: "Status", value: "isActive", align: "center" },
                { text: "Type", value: "type" },
                { text: "Hours", value: "hourLimit" },
                { text: "From", value: "from" },
                { text: "To", value: "to" },
            ],
        };
    },
    filters: {
        toShortDate(date) {
            if (date) {
                return date.split("T")[0];
            }
        },
    },
});
